import { UserAccess } from "./UserAccess";

export enum PermissionMenuName {
  dokumenKerjasama = 'dokumenKerjasama',
  monevPartner = 'monevPartner',
  partner = 'partner',
  masterData = 'masterData',
  userControl = 'userControl',
  userRole = 'userRole'
}

export const PermissionDefault: UserAccess[] = [
  {
    MENU_NAME: PermissionMenuName.dokumenKerjasama,
    ACCESS: {
      create: false,
      read: false,
      x: false,
      update: false,
      delete: false
    }
  },
  {
    MENU_NAME: PermissionMenuName.monevPartner,
    ACCESS: {
      create: false,
      read: false,
      x: false,
      update: false,
      delete: false
    }
  },
  {
    MENU_NAME: PermissionMenuName.partner,
    ACCESS: {
      create: false,
      read: false,
      x: false,
      update: false,
      delete: false
    }
  },
  {
    MENU_NAME: PermissionMenuName.masterData,
    ACCESS: {
      create: false,
      read: false,
      x: false,
      update: false,
      delete: false
    }
  },
  {
    MENU_NAME: PermissionMenuName.userControl,
    ACCESS: {
      create: false,
      read: false,
      x: false,
      update: false,
      delete: false
    }
  },
  {
    MENU_NAME: PermissionMenuName.userRole,
    ACCESS: {
      create: false,
      read: false,
      x: false,
      update: false,
      delete: false
    }
  }
];

export interface UserRole {
  ROLE_ID: number;
  NAME: string;
  STATUS: number;
  PERMISSIONS: UserAccess[];
  PERMISSION_DETAIL: UserAccess[];
}

export interface ParsedPermission {
  [key: string]: UserAccess
}